<template>
  <div class="row mt-2 mb-2 justify-center">
    <div class="col-lg-8 col-md-6 col-sm-4">
      <label><b>Tags:</b></label>
      <multiselect
        v-model="resource.tags"
        tag-placeholder="Add new"
        placeholder="Add tags here..."
        :options="allTags"
        :multiple="true"
        :taggable="true"
        @tag="addTag"
        :hideSelected="true"></multiselect>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: "resourceTag",
  props: {
    // Incoming discussion
    resource: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      allTags: "project/resources/allTags"
    }),
  },
  methods: {
    addTag(newTag) {
      this.resource.tags.push(newTag.toLowerCase())
    },
  },
}
</script>

<style scoped lang="scss">

</style>
